// SF システム権限のうち監査上「危険」とみなすものの唯一の定義（バックエンドの合成とフロントの表示で共有する）。
// key は backend の RawPermissionSet のフラグ名と一致させる（合成時にそのまま参照するため）。
import type { Severity } from "./catalog";

export type PermissionKey =
  | "modifyAllData"
  | "viewAllData"
  | "manageUsers"
  | "modifyMetadata"
  | "authorApex"
  | "manageRoles"
  | "customizeApplication"
  | "manageIpAddresses"
  | "apiEnabled";

export interface DangerousPermission {
  readonly key: PermissionKey;
  readonly label: string;
  readonly severity: Severity;
}

export const DANGEROUS_PERMISSIONS: readonly DangerousPermission[] = [
  { key: "modifyAllData", label: "全データの編集", severity: "critical" },
  { key: "viewAllData", label: "全データの参照", severity: "critical" },
  { key: "manageUsers", label: "ユーザーの管理", severity: "high" },
  { key: "modifyMetadata", label: "メタデータの編集", severity: "high" },
  { key: "authorApex", label: "Apex 開発", severity: "high" },
  { key: "manageRoles", label: "ロールの管理", severity: "high" },
  { key: "customizeApplication", label: "アプリケーションのカスタマイズ", severity: "high" },
  { key: "manageIpAddresses", label: "IP アドレスの管理", severity: "medium" },
  { key: "apiEnabled", label: "API の有効化", severity: "low" },
] as const;

// ヒートマップに出す列。apiEnabled は正当な保有者が非常に多くノイズになるため除外する
// （ユーザー詳細と CSV には全 9 種を出すので情報は隠さない）。
export const HEATMAP_PERMISSION_KEYS: readonly PermissionKey[] = DANGEROUS_PERMISSIONS
  .filter((p) => p.severity === "critical" || p.severity === "high")
  .map((p) => p.key);
